import MaterialType from '../types/api/material-type'

export const getMaterialTypes = (record: {
    material_type?: MaterialType
    additional_material_types?: MaterialType[]
}) => {
    const list: MaterialType[] = []
    if (record.material_type) list.push(record.material_type)
    if (record.additional_material_types) list.push(...record.additional_material_types)
    return list
}
